module.exports = __webpack_public_path__ + "a4863f422d1934cbd64af219de6420c7.svg";